// extracted by mini-css-extract-plugin
export var active = "palette_from_image-module--active--35225";
export var colors_from_image_wrapper = "palette_from_image-module--colors_from_image_wrapper--7a962";
export var dropd_zone_and_palette_wrapper = "palette_from_image-module--dropd_zone_and_palette_wrapper--cd447";
export var dropzone_wrapper = "palette_from_image-module--dropzone_wrapper--9c931";
export var image_palette_wrapper = "palette_from_image-module--image_palette_wrapper--7e9bb";
export var image_wrapper = "palette_from_image-module--image_wrapper--8fabb";
export var palette_from_image_wrapper = "palette_from_image-module--palette_from_image_wrapper--a05d0";